var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.layerH),expression:"layerH"}],ref:"layer",staticClass:"calendar-day-view-layer",class:[_vm.innerTheme],style:({
      top: `${_vm.layerY ? _vm.layerY + 3 : 0 }px`,
      height: `${_vm.innerTheme==='theme-create' ? 22 : _vm.layerH - 6}px`
    }),on:{"click":_vm.clickEvent}},[(_vm.innerTheme === 'theme-create')?_c('span',{staticClass:"ibass ibass-add"}):_vm._e(),_c('span',{staticClass:"calendar-day-view-layer-label",domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }